var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAv5TransitionPass = function SvgAv5TransitionPass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#42BCC7",
    "data-no-fill": "true",
    "data-no-stroke": "true"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.934 5.534-4.668 4.67L4.8 8",
    stroke: "#fff",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    "data-no-fill": "true",
    "data-no-stroke": "true"
  })));
};
export { SvgAv5TransitionPass as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTYgMTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8Y2lyY2xlIGN4PSI4IiBjeT0iOCIgcj0iOCIgZmlsbD0iIzQyQkNDNyIgZGF0YS1uby1maWxsPSJ0cnVlIiBkYXRhLW5vLXN0cm9rZT0idHJ1ZSIvPgogICAgPHBhdGggZD0iTTExLjkzNDUgNS41MzQzM0w3LjI2NTYgMTAuMjAzMkw0LjgwMDEgNy45OTk5NSIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIxLjYiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogICAgICAgICAgZGF0YS1uby1maWxsPSJ0cnVlIiBkYXRhLW5vLXN0cm9rZT0idHJ1ZSIvPgo8L3N2Zz4K";